import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/** Materials assigned to a class — used to let the director pick which to grant. */
export function useClassMaterials(classId) {
    return useQuery({
        queryKey: ['class-materials', classId],
        queryFn: () => apiClient(`/materials/class/${classId ?? ''}`),
        enabled: !!classId,
        // Avoid a focus refetch wiping the director's in-progress selection.
        staleTime: 1000 * 60 * 5,
    });
}
export function useRequests(filters = {}, options = {}) {
    return useQuery({
        queryKey: ['requests', filters],
        queryFn: () => {
            const params = new URLSearchParams();
            if (filters.status)
                params.set('status', filters.status);
            if (filters.type)
                params.set('type', filters.type);
            if (filters.resolved !== undefined)
                params.set('resolved', String(filters.resolved));
            const qs = params.toString();
            return apiClient(`/requests${qs ? `?${qs}` : ''}`);
        },
        staleTime: 1000 * 60 * 2,
        enabled: options.enabled ?? true,
    });
}
export function useRequest(id) {
    return useQuery({
        queryKey: ['requests', id],
        queryFn: () => apiClient(`/requests/${id ?? ''}`),
        enabled: !!id,
    });
}
export function useResolveRequest() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, dto }) => apiClient(`/requests/${id}/resolve`, {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['requests'] }),
    });
}
//# sourceMappingURL=useRequests.js.map